export const preferenceSelector = (state) =>
  state.getIn(['app', 'appraisalDemo', 'global', 'preference']);
export const currentSavedSearchIndexSelector = (state) =>
  state.getIn(['app', 'appraisalDemo', 'global', 'currentSavedSearchIndex']);
export const currentSearchSelector = (state) =>
  state.getIn(['app', 'appraisalDemo', 'global', 'currentSearch']);
export const selectedPropertySelector = (state) =>
  state.getIn(['app', 'appraisalDemo', 'global', 'selectedProperty']);
export const selectedYearSelector = (state) =>
  state.getIn(['app', 'appraisalDemo', 'global', 'selectedYear']);
export const editDataSelector = (state) =>
  state.getIn(['app', 'appraisalDemo', 'global', 'editData']);
export const isMenuVisibleSelector = (state) =>
  state.getIn(['app', 'appraisalDemo', 'global', 'isMenuVisible']);
